import { useObserveFiltersHeightChange } from '@/app/shared/hooks/useObserveFiltersHeightChange';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { useListingRefresh } from '../../hooks/useListingRefresh';
import { usePopstate } from '../../hooks/usePopstate';
import { useUpdateOnPageChanged as useListingByPinUpdateOnPageChanged } from '../../hooks/useUpdateOnPageChanged';
import { useUpdateSearchOffersQueryKeyIfNeeded } from '../../hooks/useUpdateSearchOffersQueryKeyIfNeeded';
import { useUserUpdate } from '../../hooks/useUserUpdate';
import { FiltersOverlayCenter } from '../FiltersOverlayCenter';

export const ActionsCenters = memoWithDisplayName(() => {
  useListingRefresh();
  useListingByPinUpdateOnPageChanged();
  useObserveFiltersHeightChange();
  usePopstate();
  useUserUpdate();
  useUpdateSearchOffersQueryKeyIfNeeded();

  return <FiltersOverlayCenter />;
}, 'ActionsCenters');
